/** API enum values for `sales_sources` on deal market comps filters. */
export const SALES_COMP_SOURCE_IDS = [
  "green_street",
  "ai_extraction",
  "web_search",
  "other_deals",
] as const;

export type SalesCompSourceId = (typeof SALES_COMP_SOURCE_IDS)[number];

export const SALES_COMP_SOURCE_OPTIONS: {
  id: SalesCompSourceId;
  label: string;
}[] = [
  { id: "green_street", label: "Green Street" },
  { id: "ai_extraction", label: "AI extraction" },
  { id: "web_search", label: "Web search" },
  { id: "other_deals", label: "Other deals" },
];

const SALES_COMP_SOURCE_ID_SET = new Set<string>(SALES_COMP_SOURCE_IDS);

export function isSalesCompSourceId(value: string): value is SalesCompSourceId {
  return SALES_COMP_SOURCE_ID_SET.has(value);
}

/** When all typical sources are selected, filters mean “no source restriction”. */
export function allSalesCompSourcesSelected(
  selected: readonly string[],
): boolean {
  return (
    selected.length === SALES_COMP_SOURCE_IDS.length &&
    SALES_COMP_SOURCE_IDS.every((id) => selected.includes(id))
  );
}
